import * as React from 'react';
import { areAnyTXPEntitiesSupported } from 'owa-txp-common';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import CelebrationObject from '../schema/CelebrationObject';
import changeCelebrationImageColor from '../utils/changeCelebrationImageColor';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import getCelebrationObject from '../utils/getCelebrationObject';
import getIsDarkTheme from 'owa-fabric-theme/lib/selectors/getIsDarkTheme';
import { getPalette } from 'owa-theme';
import getPPFCharmIdFromEvent from 'owa-calendar-charms-store/lib/utils/getPPFCharmIdFromEvent';
import { getOwaResourceUrl } from 'owa-resource-url';
import { Image } from '@fluentui/react/lib/Image';
import { isDefaultColor } from 'owa-color-utils/lib/colorUtils';
import { mergeStyles } from '@uifabric/styling';
import { observer } from 'mobx-react-lite';

let styles;
let classNames = require('classnames/bind').bind(styles);

export interface CelebrationImageProps extends React.HTMLAttributes<HTMLDivElement> {
    event: CalendarEvent;
    colorScheme: ColorScheme;
    charmId: number;
}

/**
 * Gets the correct celebration object and renders a tricolor image when the calendar color is default blue.
 * Otherwise it renders a monochrome image, injecting color into the background to match the current calendar color.
 */
const CelebrationImage = observer(function CelebrationImage(props: CelebrationImageProps) {
    let { event, colorScheme, charmId, className } = props;
    const effectiveCharmId: number = charmId ? charmId : getPPFCharmIdFromEvent(event);
    let celebrationObject: CelebrationObject = getCelebrationObject(effectiveCharmId, colorScheme);

    let txpElement: boolean = areAnyTXPEntitiesSupported(event.EntityNamesMap);
    let headerColorStyle = mergeStyles({
        backgroundColor: colorScheme ? colorScheme.calLighterAlt : getPalette().themeLighterAlt,
    });

    return celebrationObject && !txpElement ? (
        <>
            {celebrationObject &&
                (isDefaultColor(colorScheme) && !getIsDarkTheme() ? (
                    <Image
                        className={classNames(className, headerColorStyle)}
                        shouldFadeIn={false}
                        src={getOwaResourceUrl(celebrationObject.image)}
                        aria-label={celebrationObject.ariaLabel}
                    />
                ) : (
                    /**
                     * In order to inject color into the SVG image at runtime,
                     * the color value is directly replaced inside the HTML code
                     */
                    /* tslint:disable:react-no-dangerous-html */
                    <div
                        className={classNames(className, headerColorStyle)}
                        aria-label={celebrationObject.ariaLabel}
                        dangerouslySetInnerHTML={changeCelebrationImageColor(
                            colorScheme,
                            celebrationObject
                        )}
                    />
                    /* tslint:enable:react-no-dangerous-html */
                ))}
        </>
    ) : null;
});
export default CelebrationImage;
